import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pts',
  templateUrl: './pts.component.html',
  styleUrls: ['./pts.component.scss'],
})
export class PTS implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
